<template>
  <div>
    <div class="Phead">
      <div class="PheadTop">
        <div class="PheadTopLogo">
          <img src="http://hm.isdg.cn/logo50.png">
        </div>
        <div class="PheadTopImg">
          <span class="successSpan" @click="tologin()">
            <img src="../../assets/images/Head/h_user.png" >
        </span>
        </div>
      </div>
      <p class="phead_cai"></p>
    </div>

    <div class="Phead_main">
      <slideshow :slidePics="slidePics"></slideshow>
      <div class="headVideo">
        <div class="headVideoMain">
          <div class="videoMainImg">
            <img src="http://hm.isdg.cn/index/home/videotext.png"/>
          </div>
          <div class="videoMainRight">
            <video class="video" controls height="400px" width="600px">
              <source src="http://hten.isdg.cn/videosrsc.mp4" type="video/mp4">
            </video>
          </div>
        </div>
      </div>
      <div class="optyon">
        <div class="optyonImg">
          <img src="http://hm.isdg.cn/index/home/logo3bg.png"/>
        </div>
      </div>
      <goods-list :goodsInfo="goodsInfo"></goods-list>
    </div>
  </div>
</template>
<script>
  import {slideShow, goods} from './../../api/interface/common'//接口
  import {getUserInfo} from './../../api/interface/users'
  import slideshow from './../common/slideshow.vue'//跑马灯--轮播图
  import goodsList from '../goods/goods.vue'//商品信息
  import {bus} from '../../main'
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
        token: localStorage.getItem('token') || 0,
        slidePics: [],
        goodsInfo: [],
        userInfo: {}, //用户信息
        istext: false,
        islogin: localStorage.getItem('token') || "",
        head_url: localStorage.getItem('headImg') || ""
      }
    },
    beforeMount(){
    },
    methods: {
      tologin(){
          this.$router.push({path:"/login"})
      }
    },
    components: {
      slideshow,
      goodsList,
    }
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .Phead {
      width: 100%;
      .PheadTop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 999;
        width: 100%;
        height: 50px;
        display: flex;
        background-color: white;
        justify-content: space-between;
        .PheadTopLogo {
          height: 30px;
          width: 133px;
          margin-top: 10px;
          padding: 0 10/$default-w+rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .PheadTopImg {
          height: 40px;
          width: 40px;
          margin: 10px 30px 10px 0;
          .successSpan, .noSpan {
            display: inline-block;
            height: 30px;
            width: 30px;
            img {
              height: 100%;
              width: 100%;
            }
          }
        }
      }
      .phead_cai {
        z-index: 999;
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
        height: 15px;
        width: 100%;
        background: $Head_linear_ramp;
      }
    }
    .Phead_main {
      position: absolute;
      top: 65px;
      left: 0;
      right: 0;
      bottom: 50px;
      overflow-x: hidden;
      overflow-y: scroll;
      .headVideo{
        display: none;
      }
      .optyon{
        display: none;
      }
    }
  }
  @media screen and(min-width: $P750screen)and(max-width: 991px) {
    .Phead {
      display: none;
    }
    .Phead_main {
      width: 100%;
      height: 100%;
      background-image: url("../../assets/images/home/homebg.jpg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-attachment: fixed;
      background-position: center top;
      .headVideo {
        height: 400px;
        width: 100%;
        background-color: #222222;
        .headVideoMain {
          height: 400px;
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          justify-content: space-around;
          .videoMainImg {
            height: 256px;
            width: 300px;
            margin: 50px 0;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .videoMainRight {
            height: 240px;
            width: 400px;
            margin: 80px 0;
            .video {
              height: 240px;
              width: 400px;
            }
          }
        }
      }
      .optyon {
        height: 300px;
        width: 100%;
        .optyonImg {
          width: 600px;
          height: 150px;
          margin: 0 auto;
          img {
            margin-top: 75px;
            width: 100%;
            height: 100%;
          }
        }

      }
      .PFooter {
        display: none;
      }
    }
  }
  @media screen and(min-width: 992px) {
    .Phead {
      display: none;
    }
    .Phead_main {
      width: 100%;
      height: 100%;
      background-image: url("../../assets/images/home/homebg.jpg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-attachment: fixed;
      background-position: center top;
      .headVideo {
        height: 500px;
        width: 100%;
        background-color: #222222;
        .headVideoMain {
          height: 500px;
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
          /*background-color: #8ec321;*/
          display: flex;
          justify-content: space-around;
          .videoMainImg {
            height: 300px;
            width: 351px;
            margin: 100px 0;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .videoMainRight {
            height: 400px;
            width: 600px;
            margin: 50px 0;
            .video {
              height: 400px;
              width: 600px;
            }
          }
        }
      }
      .optyon {
        height: 300px;
        width: 100%;
        .optyonImg {
          width: 600px;
          height: 150px;
          margin: 0 auto;
          img {
            margin-top: 75px;
            width: 100%;
            height: 100%;
          }
        }

      }
      .PFooter {
        display: none;
      }
    }
  }


</style>




// WEBPACK FOOTER //
// src/views/home/home.vue